export default __webpack_public_path__ + "6a14b273a9085623790fa6dc895d82b8.webp";